import type { SVGProps } from "react";
export interface AxeIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AxeIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AxeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M8.728 8.267a1.124 1.124 0 0 1 1.797 1.353l-7.35 9.752.6.451 7.321-9.715.075-.09a1.126 1.126 0 0 1 1.723 1.444l-7.398 9.816a2.125 2.125 0 0 1-2.795.54l-.18-.121-.798-.602a2.126 2.126 0 0 1-.42-2.977zM16.632 6.5a1.124 1.124 0 0 1-1.798-1.353zm-2.833-4.945a2.126 2.126 0 0 1 2.657-.373l.18.121.799.602.167.14c.79.731.912 1.958.25 2.837L16.632 6.5l-1.798-1.353 1.146-1.52-.6-.452-1.117 1.484-1.797-1.353 1.194-1.584zm.464 3.104a1.126 1.126 0 1 1-1.797-1.353z"
      />
      <path
        fill={color}
        d="M8.697 2.888a3.126 3.126 0 0 1 4.386-.549l4.352 3.382c.329.256.734.395 1.151.394l3.397-.001.208.019c.473.088.847.473.908.965l-1.116.14L23.1 7.1v.003l.002.006.001.016.005.04q.005.051.01.131.01.162.007.435a8.3 8.3 0 0 1-.164 1.472c-.242 1.215-.818 2.829-2.128 4.515s-2.732 2.642-3.85 3.177a8.3 8.3 0 0 1-1.386.525 7 7 0 0 1-.423.1q-.079.014-.129.021l-.04.008h-.023l-.001.002h-.002l-.142-1.116.14 1.116a1.126 1.126 0 0 1-1.23-.839l-.838-3.291a1.87 1.87 0 0 0-.666-1.018L7.89 9.02a3.126 3.126 0 0 1-.55-4.386zM14.69 15.32l-.003.001.006-.001zM11.7 4.116a.875.875 0 0 0-1.227.154L9.117 6.016a.875.875 0 0 0 .154 1.227l4.352 3.383a4.13 4.13 0 0 1 1.467 2.24l.549 2.163q.174-.07.372-.163c.84-.402 1.972-1.149 3.044-2.528s1.515-2.66 1.698-3.574a7 7 0 0 0 .066-.4l-2.233.001a4.13 4.13 0 0 1-2.532-.868z"
      />
    </svg>
  );
}
